<form [formGroup]="form" (ngSubmit)="submitForm()">
  <h2 mat-dialog-title>Vehicle Filters</h2>
  <mat-dialog-content class="mat-typography">
    <sn-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"
      [options]="formOptions"
    ></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="danger" type="button" (click)="clearFilters()">REMOVE FILTERS</button>
    <button mat-button type="button" (click)="cancel()">CANCEL</button>
    <button mat-button type="submit" color="success" [mtBasicSpinner]="isLoading">DONE</button>
  </mat-dialog-actions>
</form>
